/**
 * Estilos del widget como string — se inyectan en el Shadow DOM al montar.
 * Sin Tailwind (evitamos su overhead en el bundle UMD); CSS plano y aislado.
 */

export const WIDGET_CSS = `
:host {
  all: initial;
  display: block;
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  color: #18181b;
  --wp-bg: #ffffff;
  --wp-fg: #18181b;
  --wp-muted: #71717a;
  --wp-border: #e4e4e7;
  --wp-border-strong: #d4d4d8;
  --wp-input-bg: #fafafa;
  --wp-brand: #6366f1;
  --wp-brand-hover: #4f46e5;
  --wp-danger: #dc2626;
  --wp-success: #16a34a;
  --wp-radius: 8px;
}

* { box-sizing: border-box; }

.wp-card {
  background: var(--wp-bg);
  border: 1px solid var(--wp-border);
  border-radius: 12px;
  padding: 24px;
  max-width: 480px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.04);
}

.wp-header {
  margin-bottom: 20px;
}
.wp-title {
  font-size: 18px;
  font-weight: 600;
  margin: 0 0 4px;
}
.wp-subtitle {
  font-size: 13px;
  color: var(--wp-muted);
  margin: 0;
}

.wp-row {
  display: flex;
  gap: 12px;
}
.wp-row > * { flex: 1; min-width: 0; }

.wp-field {
  margin-bottom: 14px;
}

.wp-label {
  display: block;
  font-size: 12px;
  font-weight: 500;
  color: var(--wp-muted);
  margin-bottom: 6px;
}

.wp-input {
  width: 100%;
  border: 1px solid var(--wp-border);
  border-radius: var(--wp-radius);
  padding: 10px 12px;
  font-size: 14px;
  background: var(--wp-input-bg);
  color: var(--wp-fg);
  transition: border-color 120ms;
  font-family: inherit;
}
.wp-input:focus {
  outline: none;
  border-color: var(--wp-brand);
  box-shadow: 0 0 0 3px rgba(99,102,241,0.15);
}
.wp-input.wp-error {
  border-color: var(--wp-danger);
}
.wp-input[disabled] {
  opacity: 0.6;
  cursor: not-allowed;
}
.wp-input.wp-input-locked,
.wp-input[readonly] {
  background: var(--wp-border);
  color: var(--wp-muted);
  cursor: not-allowed;
  opacity: 1;
}

/* Select / dropdown — mismo look que .wp-input */
.wp-select {
  width: 100%;
  border: 1px solid var(--wp-border);
  border-radius: var(--wp-radius);
  padding: 10px 36px 10px 12px;
  font-size: 14px;
  background: var(--wp-input-bg);
  color: var(--wp-fg);
  font-family: inherit;
  cursor: pointer;
  appearance: none;
  -webkit-appearance: none;
  background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8' fill='none'><path d='M1 1.5L6 6.5L11 1.5' stroke='%2371717a' stroke-width='1.5' stroke-linecap='round'/></svg>");
  background-repeat: no-repeat;
  background-position: right 12px center;
  transition: border-color 120ms;
}
.wp-select:focus {
  outline: none;
  border-color: var(--wp-brand);
  box-shadow: 0 0 0 3px rgba(99,102,241,0.15);
}
.wp-select[disabled] {
  opacity: 0.6;
  cursor: not-allowed;
}

.wp-hint {
  display: block;
  margin-top: 6px;
  font-size: 11px;
  color: var(--wp-muted);
}

.wp-pan-wrapper {
  position: relative;
}
.wp-brand-icon {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 11px;
  font-weight: 700;
  color: var(--wp-muted);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  pointer-events: none;
}

.wp-error-text {
  display: block;
  margin-top: 6px;
  font-size: 12px;
  color: var(--wp-danger);
}

.wp-hint {
  display: block;
  margin-top: 6px;
  font-size: 12px;
  color: var(--wp-muted);
}
.wp-hint-success { color: #16a34a; font-weight: 500; }

.wp-button {
  width: 100%;
  border: none;
  border-radius: var(--wp-radius);
  padding: 12px;
  font-size: 14px;
  font-weight: 600;
  background: var(--wp-brand);
  color: #fff;
  cursor: pointer;
  font-family: inherit;
  transition: background 120ms;
}
.wp-button:hover:not([disabled]) { background: var(--wp-brand-hover); }
.wp-button[disabled] { opacity: 0.5; cursor: not-allowed; }
.wp-button.wp-button-secondary {
  background: transparent;
  color: var(--wp-fg);
  border: 1px solid var(--wp-border-strong);
}
.wp-button.wp-button-secondary:hover:not([disabled]) {
  background: var(--wp-input-bg);
}

.wp-banner {
  border-radius: var(--wp-radius);
  padding: 10px 12px;
  font-size: 13px;
  margin-bottom: 14px;
}
.wp-banner-error {
  background: #fef2f2;
  color: var(--wp-danger);
  border: 1px solid #fecaca;
}
.wp-banner-success {
  background: #f0fdf4;
  color: var(--wp-success);
  border: 1px solid #bbf7d0;
}

.wp-section-title {
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--wp-muted);
  margin: 18px 0 10px;
  font-weight: 600;
}

.wp-spinner {
  display: inline-block;
  width: 14px;
  height: 14px;
  border: 2px solid rgba(255,255,255,0.4);
  border-top-color: #fff;
  border-radius: 50%;
  animation: wp-spin 0.7s linear infinite;
  margin-right: 6px;
  vertical-align: middle;
}
@keyframes wp-spin {
  to { transform: rotate(360deg); }
}

.wp-footer {
  margin-top: 12px;
  font-size: 11px;
  color: var(--wp-muted);
  text-align: center;
}

/* ---------------------------------------------------------------------------
 * THEMES
 *
 * El widget tiene 3 modos de tema, controlados por data-walletpay-theme en :host:
 *   "light"  → siempre claro (fuerza light incluso si el OS está en dark)
 *   "dark"   → siempre oscuro
 *   "auto"   → sigue prefers-color-scheme del OS (DEFAULT)
 *
 * El JS del widget pone el atributo según opts.theme. Si no se pasa nada,
 * default es "auto".
 * --------------------------------------------------------------------------- */

/* Dark explícito */
:host([data-walletpay-theme="dark"]) {
  color: #f4f4f5;
  --wp-bg: #131316;
  --wp-fg: #f4f4f5;
  --wp-muted: #a1a1aa;
  --wp-border: #27272a;
  --wp-border-strong: #3f3f46;
  --wp-input-bg: #1a1a1e;
}
:host([data-walletpay-theme="dark"]) .wp-banner-error { background: rgba(220,38,38,0.1); }
:host([data-walletpay-theme="dark"]) .wp-banner-success { background: rgba(22,163,74,0.1); }

/* Auto: sigue al OS — light por default arriba, dark si el OS lo pide */
@media (prefers-color-scheme: dark) {
  :host([data-walletpay-theme="auto"]) {
    color: #f4f4f5;
    --wp-bg: #131316;
    --wp-fg: #f4f4f5;
    --wp-muted: #a1a1aa;
    --wp-border: #27272a;
    --wp-border-strong: #3f3f46;
    --wp-input-bg: #1a1a1e;
  }
  :host([data-walletpay-theme="auto"]) .wp-banner-error { background: rgba(220,38,38,0.1); }
  :host([data-walletpay-theme="auto"]) .wp-banner-success { background: rgba(22,163,74,0.1); }
}

/* ---------------------------------------------------------------------------
 * VERIFICACIÓN BIOMÉTRICA
 * --------------------------------------------------------------------------- */

/* Banner informativo (azul) — usado en las pantallas de preparación/captura */
.wp-banner-info {
  background: #eff6ff;
  color: #1d4ed8;
  border: 1px solid #bfdbfe;
}
:host([data-walletpay-theme="dark"]) .wp-banner-info {
  background: rgba(59,130,246,0.12);
  color: #93c5fd;
  border-color: rgba(59,130,246,0.3);
}
@media (prefers-color-scheme: dark) {
  :host([data-walletpay-theme="auto"]) .wp-banner-info {
    background: rgba(59,130,246,0.12);
    color: #93c5fd;
    border-color: rgba(59,130,246,0.3);
  }
}

/* Spinner sobre fondo claro (el .wp-spinner base es blanco, para botones) */
.wp-spinner-dark {
  border-color: rgba(99,102,241,0.25);
  border-top-color: var(--wp-brand);
  width: 28px;
  height: 28px;
  margin: 0;
}

.wp-bio-center { text-align: center; padding: 16px 0; }
.wp-bio-muted { color: var(--wp-muted); font-size: 13px; margin: 8px 0 0; line-height: 1.5; }
.wp-bio-tight { margin-top: 0; }

/* Lista de pasos (cédula, selfie) */
.wp-bio-steps {
  list-style: none;
  padding: 0;
  margin: 14px 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.wp-bio-steps li {
  display: flex;
  gap: 10px;
  align-items: flex-start;
  font-size: 13px;
  line-height: 1.4;
}
.wp-bio-step-ico { font-size: 20px; line-height: 1.2; flex-shrink: 0; }

/* Preview de la cámara del usuario (camera-bridge) */
.wp-bio-cam-wrap {
  position: relative;
  width: 100%;
  aspect-ratio: 4 / 3;
  border-radius: var(--wp-radius);
  overflow: hidden;
  background: #000;
  margin: 12px 0;
}
.wp-bio-video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  /* Espejo, como una selfie-cam — más natural para el usuario. */
  transform: scaleX(-1);
  background: #000;
}
/* Overlay mientras la cámara aún no conecta (no se muestra el video). */
.wp-bio-cam-connecting {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  background: #000;
}

/* Marco de esquinas centrado (replica el frame de Onfido Motion): cuadro chico
   con corner-brackets donde el usuario coloca su rostro. */
.wp-bio-frame {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 40%;
  aspect-ratio: 4 / 5;
  transform: translate(-50%, -50%);
  border-radius: 18px;
  box-shadow: 0 0 0 1000px rgba(0, 0, 0, 0.4);
  pointer-events: none;
}
.wp-bio-corner {
  position: absolute;
  width: 26px;
  height: 26px;
  border: 3px solid rgba(255, 255, 255, 0.95);
}
.wp-bio-corner.tl { top: -2px; left: -2px; border-right: none; border-bottom: none; border-top-left-radius: 14px; }
.wp-bio-corner.tr { top: -2px; right: -2px; border-left: none; border-bottom: none; border-top-right-radius: 14px; }
.wp-bio-corner.bl { bottom: -2px; left: -2px; border-right: none; border-top: none; border-bottom-left-radius: 14px; }
.wp-bio-corner.br { bottom: -2px; right: -2px; border-left: none; border-top: none; border-bottom-right-radius: 14px; }

/* Subida de documento (cédula): dropzone + preview. */
.wp-bio-doc-drop {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 180px;
  margin-top: 12px;
  border: 2px dashed #d4d4d8;
  border-radius: 12px;
  background: #fafafa;
  cursor: pointer;
  overflow: hidden;
}
.wp-bio-doc-placeholder {
  color: #71717a;
  font-size: 15px;
  font-weight: 600;
}
.wp-bio-doc-preview {
  width: 100%;
  max-height: 280px;
  object-fit: contain;
  display: block;
}

/* Instrucción persistente y clara durante la grabación (ambos lados). */
.wp-bio-instruction {
  margin: 0 0 4px;
  font-size: 14px;
  line-height: 1.4;
  color: var(--wp-text, #18181b);
  text-align: center;
}

/* Mensaje rotando mientras el scrapper procesa (paso 3→4). */
.wp-bio-prepare-msg {
  margin: 14px 0 0;
  font-size: 16px;
  font-weight: 600;
  text-align: center;
  color: var(--wp-text, #18181b);
  min-height: 44px;
  transition: opacity 0.3s ease;
}

/* Prompt de liveness en vivo (Onfido Motion) — banda grande sobre la cámara. */
.wp-bio-prompt {
  position: absolute;
  top: 10px;
  left: 10px;
  right: 10px;
  padding: 12px 14px;
  border-radius: 12px;
  background: rgba(99, 102, 241, 0.92);
  color: #fff;
  font-size: 17px;
  font-weight: 700;
  line-height: 1.25;
  text-align: center;
  backdrop-filter: blur(4px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);
  animation: wp-pulse 1.6s ease-in-out infinite;
}
.wp-bio-prompt-hint {
  margin: 8px 0 0;
  text-align: center;
  font-size: 13px;
  font-weight: 600;
  color: var(--wp-primary, #6366f1);
}
.wp-bio-cam-badge {
  position: absolute;
  left: 10px;
  bottom: 10px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 10px;
  border-radius: 999px;
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  font-size: 12px;
  font-weight: 500;
  backdrop-filter: blur(4px);
}
.wp-bio-cam-badge-live::before {
  content: '';
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #4ade80;
  box-shadow: 0 0 0 0 rgba(74, 222, 128, 0.6);
  animation: wp-pulse 1.4s ease-in-out infinite;
}
.wp-spinner-sm { width: 12px; height: 12px; border-width: 2px; margin: 0; }

/* Tira de estado en vivo (punto + texto) */
.wp-bio-strip {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 14px;
  padding-top: 12px;
  border-top: 1px solid var(--wp-border);
}
.wp-bio-strip-text { font-size: 12px; color: var(--wp-muted); }
.wp-bio-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--wp-muted);
  flex-shrink: 0;
}
.wp-bio-dot-live { background: var(--wp-success); }
.wp-bio-dot-pulse { animation: wp-pulse 1.4s ease-in-out infinite; }
@keyframes wp-pulse { 0%,100% { opacity: 1; } 50% { opacity: 0.35; } }

/* Badges de resultado (verificado / rechazado / timeout) */
.wp-bio-badge {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  font-weight: 700;
  margin: 4px auto 8px;
}
.wp-bio-badge-ok { background: #f0fdf4; color: var(--wp-success); border: 2px solid #bbf7d0; }
.wp-bio-badge-err { background: #fef2f2; color: var(--wp-danger); border: 2px solid #fecaca; }
.wp-bio-badge-warn { background: #fffbeb; color: #d97706; border: 2px solid #fde68a; }
.wp-bio-result-title { font-size: 16px; font-weight: 600; margin: 4px 0 0; }
`;
